import styled from "styled-components";

export const Admi = styled.div`

.table{
    display: flex;
    justify-content: center;
}
.table table tr{
    margin: 20px;
}
.desc{
    line-height: 1.5em;
    font-size: 0.9em;
    font-weight: normal;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2; 
    -webkit-box-orient: vertical; 
    border: none;
    
  
}
th{
    border: 1px solid #ddd;
    padding: 5px 8px;
    font-weight: 500;
    text-align: left;
    background-color: #04AA6D;
    color: white;
}

tr:nth-child(even){background-color: #020202;} 

tr{
    height: 30px;
    overflow: hidden;
    cursor: pointer;
} 
td{ 
    
    border: 1px solid #ddd;
    padding: 3px 20px;
    padding: auto 10px;
    font-weight: 500;
    color: aliceblue;
    height: 100%
}
.item-type{
    display: flex;
    justify-content: center;
    margin: 25px;
}
.item-type div{
    margin: 15px;
}
.item-type div label{
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 50px;
}
.menu-filt{
    margin-top: 100px;
    display: flex;
    justify-content: center;
}
.menu-filt button{
    
    margin-top: 10px;
    font-weight: 500;
    align-self: center;
    height: 90px;
}
.menu-inwrap{
    background-color: #020202;
    width: 400px;
}
.menu-inwrap div{
    margin: 20px;
}
.opt{
    display: flex;
    justify-content: space-between;
   
   
}
.opt span{
    width: 100%;
    box-sizing: border-box;
    
}
.opt span label{
    font-weight: 500;
    color: #fff;
}
.header{
    display: flex;
    justify-content: center;
    position: fixed;
    background-color: #000;
    top: 0px;
    left: 0px;
    right: 0px;
}
.header h2, .header img{
  margin: 0px 15px;
}
.header h2{
    color: #fff;
    align-self: center;
}
.btns-del{
    
    display: flex;
    justify-content: space-between;
}
`